<template>
  <div>
    <v-img
      contain
      max-height="250"
      :src="require('../assets/logo.png')"
    ></v-img>
    <sheet-table
      :sheets="this.$store.state.parashah.sheets"
      :title="'This week\'s parasha is: ' + this.$store.state.parashah.parashah"
    ></sheet-table>
  </div>
</template>
<script>
import SheetTable from "./SheetTable";

export default {
  components: { SheetTable },
};
</script>
